/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(window).on('load', ()=> {
  // --- ページ遷移時のアンカーリンク ---
  const url = $(location).attr('href'),
  // 30pxの余白を追加
  headerHeight = $('header').outerHeight() + 30;

  // urlに「#」が含まれていた場合
  if(url.indexOf("#") != -1){
    const anchor = url.split("#"),
    target = $('#' + anchor[anchor.length - 1]),
    position = Math.floor(target.offset().top) - headerHeight;
    $("html, body").animate({scrollTop:position}, 500);
  }


  // --- 同じページ内のアンカーリンク ---
  const smoothScrollTrigger = $('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = $('#' + href.replace('#', ''));
      const position = Math.floor(targetElement.offset().top) - headerHeight;
      $("html, body").animate({scrollTop:position}, 500);
    });
  }
});
